// extracted by mini-css-extract-plugin
export default {"wrapper":"Detail_wrapper__CbS-v","contentWrap":"Detail_contentWrap__KwkJ3","col":"Detail_col__1FWxz"};